<template>
  <div class="all">
    <el-row align="top" class="top">
      <div link style="padding-left: 10px; display: flex; align-items: center">
        <img
          class="dllogo"
          src="../assets/logo1.png"
        />
        <span class="nav-top">登录</span>
        <span class="goguanwang" @click="goToWebsite">返回官网</span>
      </div>
      <div style="flex-grow: 1" />
    </el-row>
    
    <div class="tixing">
        <i class="el-icon-warning-outline" style="font-weight: bold;"></i>
        <div style="margin-left:10px;font-size:13px">山东一级节点数据中心，覆盖三大运营商，拥有海量优质带宽资源，由专业运维工程师团队<span style="font-weight: bold;">全年365天7*24小时</span>守护服务器安全，一站式托管，为客户提供高质量运维服务。</div>
    </div>

    <div
      style="
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 86%;
      "
    >
      <div
        style="
          flex: 1 1 auto;
          margin: 0 auto;
          display: flex;
          align-items: center;
          flex-flow: row nowrap;
          -ms-flex-pack: center;
          justify-content: center;
        "
      >
        <div class="left-image-div">
          <div class="margin28">
            <h3 class="heading">🎉山东亿信通</h3>
            <span class="subheading">高防服务器</span>
            <span class="upgrade">全新升级</span>
          </div>
          <div>
            <div class="panel-item">🟣三线BGP服务器，优秀网络质量，可靠稳定</div>
            <div class="panel-item">
              🔵网络应用安全，保护网络应用程序免受攻击
            </div>
            <div class="panel-item">
              🟤等保一体化服务，为企业提供信息安全保障
            </div> 
          </div>
          <div style="margin-top: 40px">
            <div class="mianfeishiyong">立即免费使用</div>
          </div>
        </div>
        <div class="login-form-div">
          <div class="Upperrightcorner" @click="formChange" v-if="!wxShow">
            <span class="Upperrightc-span">
              {{ formType == "login" ? "注册" : (formType == "forget" ? "忘记密码" : "登录") }}
            </span>
          </div>
          <div v-if="formType == 'login'">
            <el-tabs
              v-if="!wxShow"
              v-model="activeName"
              class="demo-tabs"
              @tab-click="handleClick"
              style="padding: 40px 48px 22px"
            >
              <el-tab-pane label="账号登录" name="accountLogin">
                <el-form :model="loginForm" style="width: 100%">
                  <div style="maring: 10px">
                    <el-input
                      ref="inputRefPassword"
                      autofocus
                      v-model="loginForm.account"
                      placeholder="请输入登录账号"
                      clearable
                      style="
                        height: 50px;
                        margin-bottom: 10px;
                        margin-top: 30px;
                      "
                    />
                  </div>
                  <div style="maring: 10px">
                    <el-input
                      type="password"
                      show-password
                      v-model="loginForm.password"
                      placeholder="请输入登录密码"
                      clearable
                      style="height: 50px; margin-bottom: 10px"
                    />
                  </div>
                  <div style="font-size: 14px; color: #979797">
                    还没有账号？立即
                    <span
                      @click="formChange"
                      class="freezhuce"
                      style="color: #667fa0"
                      >免费注册</span
                    >
                    <!-- <span style="float: right;" class="freezhuce" @click="forgetPassword">忘记密码?</span> -->
                  </div>

                  <el-form-item>
                    <el-button
                      type="primary"
                      @click.prevent="accountlogin()"
                      class="denglubutton"
                    >
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <span style="display: felx">登录</span>
                        <span><i class="el-icon-right"></i></span>
                      </div>
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane label="手机号登录" name="phoneLogin">
                <el-form :model="loginForm2" style="width: 100%">
                  <div label="">
                    <el-input
                      ref="inputRef"
                      autofocus
                      v-model="loginForm2.phone"
                      placeholder="请输入手机号"
                      style="
                        height: 50px;
                        margin-bottom: 10px;
                        margin-top: 30px;
                      "
                    />
                  </div>
                  <div label="" style="display: flex">
                    <el-input
                      v-model="loginForm2.smsCode"
                      placeholder="请输入验证码"
                      style="flex: 1; height: 50px; margin-bottom: 10px"
                    />
                    <el-button
                      style="
                        border: 0px;
                        border-left: 1px solid var(--el-border-color);
                        border-radius: 0px;
                        height: 40px;
                      "
                      :disabled="isWaiting"
                      @click="getregistercode()"
                    >
                      {{ btnText }}
                    </el-button>
                  </div>

                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="phonelogin()"
                      class="denglubutton"
                    >
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <span style="display: felx">登录</span>
                        <span><i class="el-icon-right"></i></span>
                      </div>
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>

              <!-- 子账号 -->
              <el-tab-pane label="子账号登录" name="childLogin">
                <el-form :model="loginForm3" style="width: 100%">
                  <div label="">
                    <el-input
                      ref="childInputRef"
                      autofocus
                      v-model="loginForm3.account"
                      placeholder="请输入登录账号"
                      clearable
                      style="
                        height: 50px;
                        margin-bottom: 10px;
                        margin-top: 30px;
                      "
                    />
                  </div>
                  <div label="" style="display: flex">
                    <el-input
                      type="password"
                      show-password
                      v-model="loginForm3.password"
                      placeholder="请输入登录密码"
                      clearable
                      style="flex: 1; height: 50px; margin-bottom: 10px"
                    />
                  </div>

                  <el-form-item>
                    <el-button
                      type="primary"
                      @click="childlogin()"
                      class="denglubutton"
                    >
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <span style="display: felx">登录</span>
                        <span><i class="el-icon-right"></i></span>
                      </div>
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <!-- 微信二维码  -->
            <div v-if="!wxShow" class="wxbottom" key="qrcode-container">
              <el-divider>
                <div style="display: flex; align-items: center">
                  <div class="scan-container" style="margin-right: 6px">
                    <div class="scan-container1">
                      <div class="scan-container-corner corner-top-left"></div>

                      <div class="scan-container-corner corner-top-right"></div>
                      <div
                        class="scan-container-corner corner-bottom-left"
                      ></div>
                      <div
                        class="scan-container-corner corner-bottom-right"
                      ></div>
                    </div>
                    <div class="scan-container2">
                      <img
                        src="../assets/qrcode.png"
                        style="
                          width: inherit;
                          height: inherit;
                          object-fit: contain;
                        "
                      />
                    </div>
                    <div class="scan-container3">
                      <div class="scan-animate"></div>
                    </div>
                  </div>
                  微信扫码登录
                </div>
              </el-divider>
              <div ref="loginContainer" id="login_container" style="height: 150px" />
              <div style="display: flex; align-items: center; margin-top: 10px">
                <span style="font-size: 12px"
                  >打开微信【扫一扫】功能，扫描二维码</span
                >
              </div>
            </div>
            <div style="padding: 40px 48px 22px" v-if="wxShow" key="account-container">
              <p style="font-size: 18px; margin-bottom: 15%;color:blue;cursor:pointer" @click="wxbacklogin">
                <i class="el-icon-back"></i>返回登录
              </p>
              <div style="font-size: 30px; font-weight: bold; margin: 20px 0">
                选择登录账号
              </div>
              <div style="margin: 20px 0">
                当前登录方式有<span style="color: #5cb96b">{{
                  wxList.length
                }}</span
                >个关联账号,请选择登陆方式
              </div>
              <div style="font-size: 15px; font-weight: bold; margin: 10px 0">
                主账号
              </div>
              <div
                class="zhuzhanghao"
                v-for="(item, index) in wxList"
                :key="index"
                @click="wxChangeUserlogin(item)"
              >
                {{ item.nickName }}({{ item.phone }})
              </div>
            </div>
          </div>
          <!-- 注册表单 -->
          <div style="padding: 40px 48px 22px" v-if="formType == 'register'">
            <p style="font-size: 22px; margin-bottom: 15%">用户注册</p>
            <el-form
              ref="zhuceForm"
              :model="zhuceForm"
              :rules="zhucedata"
              status-icon
            >
              <el-form-item label="" prop="phone">
                <el-input
                  autofocus
                  v-model="zhuceForm.phone"
                  placeholder="请输入手机号"
                />
              </el-form-item>
              <el-form-item class="phoneyzm" prop="smsCode">
                <el-input
                  v-model="zhuceForm.smsCode"
                  placeholder="请输入验证码"
                />
                <el-button
                  style="
                    border: 0px;
                    border-left: 1px solid var(--el-border-color);
                    border-radius: 0px;
                    height: 40px;
                  "
                  :disabled="ZCphonecmsWaiting"
                  @click="getZCphoneyanzheng()"
                  class="zcbut"
                  >{{ ZCphonecmsText }}</el-button
                >
              </el-form-item>
              <el-form-item label="" prop="password">
                <el-input
                  show-password
                  type="password"
                  v-model="zhuceForm.password"
                  placeholder="请设置密码（6-20位数字大小写字母组合）"
                />
              </el-form-item>
              <el-form-item label="" prop="repeatPassword">
                <el-input
                  show-password
                  type="password"
                  v-model="zhuceForm.repeatPassword"
                  placeholder="请确认密码"
                />
              </el-form-item>
              <!-- 选择销售必填  -->
              <!-- <el-form-item prop="sysUserId" v-if="saleType == true">
                <el-select
                  v-model="zhuceForm.sysUserId"
                  placeholder="请选择销售"
                  size="large"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in sysData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->

              <!-- 选择销售不必填  -->
              <el-form-item  v-if="saleType == true">
                <el-select
                  v-model="zhuceForm.sysUserId"
                  placeholder="请选择销售"
                  size="large"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in sysData"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="zhuceForm.qq"
                  placeholder="请输入QQ(非必填)"
                />
              </el-form-item>

              <el-form-item style="margin-top: 20px">
                <el-button
                  type="primary"
                  @click="checkForm()"
                  class="denglubutton"
                >
                  注册
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 忘记密码 -->
          <div style="padding: 40px 48px 22px" v-if="formType == 'forget'">
            <p style="font-size: 18px; margin-bottom: 15%;color:blue;cursor:pointer" @click="backlogin">
              <i class="el-icon-back"></i>返回登录
            </p>
          </div>
        </div>
      </div>
    </div>
    <div align="bottom" class="bottom">
      <div class="bottom-content">
        <p>Copyright © 2024-2024 山东亿信通网络科技有限公司 版权所有</p>
        <p>
          <a
            href="https://dxzhgl.miit.gov.cn/#/home"
            target="_blank"
            style="color: #494a4a; text-decoration: none"
          >
            《中华人民共和国增值电信业务经营许可证》编号：鲁ICP16037675号-2
          </a>
          <img style="width: 14px" src="../assets/wangbei.jpg" />
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37040302000414号"
            target="_blank"
            style="color: #494a4a; text-decoration: none"
          >
            鲁公网安备 37040302000414号
          </a>
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import {
  UserLogin,
  GetPhoneCode,
  UserRegister,
  UserWxlogin,
  GetSysSale,
  GetSecurityEmail,
  UserSubLogin,
  wxAppLoginUser,
} from "../api/user";
import { encrypt } from "@/plugins/encrypt";

export default {
  data() {
    return {
      // tabs标签页
      activeName: "accountLogin",
      logintype: 1,
      // 账号登陆form
      loginForm: {
        account: "",
        password: "",
      },
      // 手机号登录form
      loginForm2: {
        phone: "",
        smsCode: "",
      },
      // 子账号登录
      loginForm3: {
        account: "",
        password: "",
      },
      // 注册form
      registerForm: {
        phone: "",
        smsCode: "",
      },
      btnText: "获取验证码",
      isWaiting: false,
      ZCphonecmsText: "获取验证码", //注册时获取手机号验证码
      ZCphonecmsWaiting: false,
      ZCyxcmsText: "获取验证码", //注册时获取邮箱验证码
      ZCyxcmsWaiting: false,
      // 微信
      wxLoginOpion: {
        appid: "wx22f223eabee2015c",
        redirectUrl: "/login",
      },
      // 微信登陆接口参数
      wxlogincs: {
        code: "",
        state: "",
      },

      identifyCodes: "1234567890",
      identifyCode: "",
      // 校验规则
      rulesdata1: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      // 销售Data
      sysData: [],
      zhuceCard: false, //默认等于false,false为默认是登录页面
      zhuceForm: {},
      // 验证规则
      zhucedata: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        // password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在 6 到 20 个字符",
            trigger: "blur",
          },
          { validator: this.validatePassword, trigger: "blur" },
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        emailCode: [
          { required: true, message: "请输入邮箱验证码", trigger: "blur" },
        ],
        phone: [
          {
            validator: this.validatePhone,
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        smsCode: [
          { required: true, message: "请输入手机验证码", trigger: "blur" },
        ],
        sysUserId: [
          { required: true, message: "请选择销售", trigger: "change" },
        ],
        repeatPassword: [
          { validator: this.validateRepeatPassword, trigger: "blur" },
        ],
      },

      saleType: true, //展示销售选项,如果为false就不展示
      saleId: "", //复制过来路径的id

      formType: "login",

      wxShow: false,
      wxList: [],
    };
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeyDown);

    console.log(this.getQueryString("code"));
    // 判断是不是销售的地址过来的
    // console.log(this.$route.query);
    if (this.$route.query.saleId) {
      // console.log("有id");
      this.saleId = this.$route.query.saleId;
      // console.log(this.saleId);
      this.saleType = false;
      this.zhuceForm.sysUserId = this.saleId;
      this.formType = "register";
    } else {
      console.log("无id");
    }
    // console.log(this.zhuceForm);
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    // 原始处理 不好使就用这个
    // let code = location.href.split("?")[1];
    // if (code) {
    //   code = code.substring(5, code.indexOf("&"));
    //   this.wxlogincs.code = code;
    // }
    // let state = location.href.split("?")[1];
    // state = state.split("state=")[1].split("#")[0];
    // this.wxlogincs.state = state;

    let href = location.href;
    let state = "";
    if (href.includes("state=")) {
      state = href.split("state=")[1].split("#")[0];
      this.wxlogincs.state = state;
    }
    console.log(state);
    if (href.includes("?")) {
      let code = href.split("?")[1];
      console.log(code.includes("saleId"));
      console.log(code);
      if (code.includes("code")) {
        code = this.getQueryString("code");
        // code = code.substring(5, code.indexOf("&"));
        this.wxlogincs.code = code;
        this.wxShow = true;
        this.wxloginjk();
      }
    }

    // 根据路径做判断

    this.getsyslale();

    // const s = document.createElement('script');
    // s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
    // this.$nextTick(() => {
    //     document.body.appendChild(s);
    //   });
    this.initWeChatLogin();
  },
  beforeDestroy() {
    // 在组件销毁时解除键盘事件注册
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    // 跳转官网
    goToWebsite() { 
    window.location.href = 'https://yxtidc.com';
  },
    formChange() {
      if (this.formType == "login") {
        this.formType = "register";
      } else if (this.formType == "register") {
        this.formType = "login";
        this.$nextTick(() => {
          this.initWeChatLogin();
        });
      }
      console.log(this.formType);
    },
    forgetPassword(){
      this.formType = "forget"
    },
    // 返回登录
    backlogin(){
      if(this.formType=='forget'){
        this.formType = "login";
      }
    },
    // wx登录返回登陆页面
    wxbacklogin(){
      this.wxShow = false
      this.formType = "login";
      const url = new URL(window.location.href);
      url.searchParams.delete("code");
      url.searchParams.delete("state");
      window.history.replaceState({}, document.title, url.toString());
      this.wxloginjk();
      console.log(this.formType);
    }, 
    // 点击回车
    handleKeyDown(event) {
      if (event.key === "Enter") {
        if (this.activeName == "accountLogin") {
          console.log("账号登录");
          this.accountlogin();
        } else if (this.activeName == "phoneLogin") {
          console.log("手机号登录");
          this.phonelogin();
        } else if (this.activeName == "childLogin") {
          console.log("子账号登录");
          this.childlogin();
        }
      }
    },
    // 获取url参数的token方法
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    // tabs标签页
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.label == "手机号登录") {
        this.$nextTick(() => {
          if (this.$refs.inputRef) {
            this.$refs.inputRef.focus();
          }
        });
      }
      if (tab.label == "账号登录") {
        this.$nextTick(() => {
          if (this.$refs.inputRefPassword) {
            this.$refs.inputRefPassword.focus();
          }
        });
      }
      if (tab.label == "子账号登录") {
        this.$nextTick(() => {
          if (this.$refs.childInputRef) {
            this.$refs.childInputRef.focus();
          }
        });
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },

    // 账号登录按钮
    async accountlogin() {
      // 判断是否输入账号和密码
      if (this.loginForm.account != "" && this.loginForm.password != "") {
        // console.log(encrypt(this.loginForm.password));
        this.loginForm.password = encrypt(this.loginForm.password);
        let response = await UserLogin(this.loginForm);
        // console.log(response);
        if (response.code == 200) {
          // 请求成功
          // console.log(encrypt(this.loginForm.password))
          // console.log(response);
          this.$message.success("登录成功");
          this.loginForm.account = "";
          this.loginForm.password = "";
          // token存缓存
          localStorage.setItem("customlogintoken", response.data.token);
          localStorage.setItem(
            "usersubType",
            JSON.stringify(response.data.user.user)
          );
          this.$router.push("/secure");
          // 存用户名id缓存
          localStorage.setItem(
            "customusernametitle",
            response.data.user.user.id
          );
        } else {
          this.$message.error(response.msg);
          this.loginForm.account = "";
          this.loginForm.password = "";
        }
      } else {
        this.$message.error("请填写完整的登录信息");
        this.loginForm.account = "";
        this.loginForm.password = "";
      }
    },
    // 注册时获取验证码
    async getregistercode() {
      this.btnText = Number(60);
      this.isWaiting = true;
      this.time();
      let phone = this.registerForm.phone || this.loginForm2.phone;
      let data = await GetPhoneCode({ phone: phone });
      // console.log(data);
      if (data.code == 200) {
        this.$message.success("发送成功");
      } else {
        this.$message.error(data.msg);
      }
    },
    time() {
      let time = setInterval(() => {
        if (this.btnText > 0) {
          this.btnText--;
        } else {
          clearInterval(time);
          this.btnText = "获取验证码";
          this.isWaiting = false;
        }
      }, 1000);
    },
    // 点击微信登录
    // wxlogin() {
    //   let redirectUrl =
    //     "https://caiwu.yxtidc.com" + this.wxLoginOpion.redirectUrl; //process.env.VUE_APP_BASE_API+redirectUrl = encodeURIComponent(redirectUrl)
    //   let state = this.randomState();
    //   let url = `https://open.weixin.qq.com/connect/qrconnect?appid=${this.wxLoginOpion.appid}`;
    //   url += `&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_login`;
    //   url += `&state=${state}#wechat_wechat_redirect`;
    //   window.location.href = url;
    // },

    // 微信登陆内嵌页面
    initWeChatLogin() {
      var wxLogin = new WxLogin({
        self_redirect: false,
        id: "login_container", // 确保这个 id 是唯一的，并且不会被其他操作修改
        appid: this.wxLoginOpion.appid,
        scope: "snsapi_login",
        redirect_uri: "https://caiwu.yxtidc.com/login",
        state: this.randomState(),
        style: "",
        stylelite: 1,
        fast_login: 1,
      });
    },

    // state生成随机字符串
    randomState() {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let state = "";
      for (let i = 0; i < 16; i++) {
        state += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      return state;
    },
    // 微信登陆接口
    async wxloginjk() {
      // console.log(this.wxlogincs);
      let obj = this.wxlogincs;
      let data = await UserWxlogin(obj);
      if (data.code == 200) {
        console.log(data);
        this.wxList = data.data.userList;
        // 隐藏二维码容器
        document.getElementById('login_container').style.display = 'none';
        // this.$message.success("登录成功");
        // localStorage.setItem("customlogintoken", data.data.token);
        // localStorage.setItem("customusernametitle", data.data.user.user.id);
        // localStorage.setItem(
        //   "usersubType",
        //   JSON.stringify(data.data.user.user)
        // );
        // this.$router.push("/secure");
      } else {
        this.$message.error(data.msg);
        this.wxShow = false;
        // 清空 URL 中的 code 和 state 参数
        const url = new URL(window.location.href);
        url.searchParams.delete("code");
        url.searchParams.delete("state");
        // 使用 history.replaceState 清空 URL 中的参数
        window.history.replaceState({}, document.title, url.toString());
        // 设置定时器，1秒后重新初始化微信登录
        setTimeout(() => {
          this.initWeChatLogin();
        }, 1000);
      }
    },

    // 微信选择账号登录
    wxChangeUserlogin(e) {
      console.log(e);
      this.wxapploginuser(e.phone, e.code);
    },
    async wxapploginuser(a, b) {
      console.log(a, b);
      let data = await wxAppLoginUser({
        phone: a,
        code: b,
      });
      if (data.code == 200) {
        this.$message.success("登录成功");
        localStorage.setItem("customlogintoken", data.data.token);
        localStorage.setItem("customusernametitle", data.data.user.user.id);
        localStorage.setItem(
          "usersubType",
          JSON.stringify(data.data.user.user)
        );
        this.$router.push("/secure");
      } else {
        console.log("wxerror");
        this.$message.error(data.msg);
      }
    },

    // 手机号按钮登录
    async phonelogin() {
      let form = this.loginForm2;
      let data = await UserLogin(form);
      // console.log(data);
      if (data.code == 200) {
        this.$message.success("登录成功");
        localStorage.setItem("customlogintoken", data.data.token);
        localStorage.setItem("customusernametitle", data.data.user.user.id);
        localStorage.setItem(
          "usersubType",
          JSON.stringify(data.data.user.user)
        );
        this.$router.push("/secure");
      } else {
        this.$message.error(data.msg);
      }
    },
    // 获取销售接口
    async getsyslale() {
      let data = await GetSysSale();
      // console.log(data);
      if (data.code == 200) {
        this.sysData = data.data;
      } else {
        this.$message.error(data.msg);
      }
    },
    // 重置按钮
    clearinput() {
      this.loginForm = {};
      this.loginForm2 = {};
      this.registerForm = {};
    },

    // 注册时发送邮箱验证码
    getzhuceyanzheng() {
      this.getemaliSms();
    },
    // 获取发送邮箱验证码数据
    async getemaliSms() {
      this.ZCyxcmsText = Number(60);
      this.ZCyxcmsWaiting = true;
      this.youxiangYzTime();
      let email = this.zhuceForm.email;
      let data = await GetSecurityEmail({ email: email });
      // console.log(data);
      if (data.code == 200) {
        this.$message.success("操作成功");
      } else {
        this.$message.error(data.msg);
      }
    },
    youxiangYzTime() {
      let youxiangYzTime = setInterval(() => {
        if (this.ZCyxcmsText > 0) {
          this.ZCyxcmsText--;
        } else {
          clearInterval(youxiangYzTime);
          (this.ZCyxcmsText = "获取验证码"), (this.ZCyxcmsWaiting = false);
        }
      }, 1000);
    },
    // 注册时发送手机号验证码
    getZCphoneyanzheng() {
      this.getzhucephonecode();
    },
    // 注册时点击发送手机号按钮
    async getzhucephonecode() {
      this.ZCphonecmsText = Number(60);
      this.ZCphonecmsWaiting = true;
      this.phoneYzTime();
      let phone = this.zhuceForm.phone;
      let data = await GetPhoneCode({ phone: phone });
      // console.log(data);
      if (data.code == 200) {
        this.$message.success("操作成功");
      } else {
        this.$message.error(data.msg);
      }
    },
    phoneYzTime() {
      let phoneYzTime = setInterval(() => {
        if (this.ZCphonecmsText > 0) {
          this.ZCphonecmsText--;
        } else {
          clearInterval(phoneYzTime);
          (this.ZCphonecmsText = "获取验证码"),
            (this.ZCphonecmsWaiting = false);
        }
      }, 1000);
    },
    // 点击注册按钮
    zhuce() {
      this.zhuceCard = true;
    },

    // 返回登陆按钮
    loginback() {
      this.zhuceCard = false;
    },
    // 订单校验方法
    checkForm() {
      this.$refs.zhuceForm.validate((valid, msg) => {
        if (valid) {
          this.zhuceyemianZC();
        } else {
          this.$message.error("请将表格填写完整");
          return false;
        }
      });
    },
    // 点击注册页面的注册按钮
    zhuceyemianZC() {
      // console.log(this.zhuceForm);
      this.zhuceForm.password = encrypt(this.zhuceForm.password);
      // console.log(this.zhuceForm.password);
      this.register();
    },
    // 点击注册页面注册按钮的数据
    async register() {
      let form = this.zhuceForm;
      console.log(form);
      let data = await UserRegister(form);
      // console.log(data);
      if (data.code == 200) {
        this.$message.success("注册成功");
        localStorage.setItem("customlogintoken", data.data.token);
        localStorage.setItem("customusernametitle", data.data.user.user.id);
        localStorage.setItem(
          "usersubType",
          JSON.stringify(data.data.user.user)
        );
        this.$router.push("/secure");
      } else {
        this.$message.error(data.msg);
        this.zhuceForm.password = "";
        this.zhuceForm.repeatPassword = "";
      }
    },
    // 判断两次密码输入的一样
    validateRepeatPassword(rule, value, callback) {
      if (value !== this.zhuceForm.password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    },
    // 判断密码是不是数字加字母
    validatePassword(rule, value, callback) {
      const regExp =
        /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*()-=,.\/])[0-9A-Za-z!@#$%^&*()-=,.\/]{6,20}$/;
      if (regExp.test(value)) {
        callback();
      } else {
        callback(new Error("密码必须包含数字和字母或其他字符"));
      }
    },
    validatePhone(rule, value, callback) {
      const regExp = /^[0-9]{11,20}$/;
      if (regExp.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    },

    // 子账号登录按钮
    childlogin() {
      console.log(this.loginForm3);
      this.usersublogin();
    },
    // 子账号登陆接口
    async usersublogin() {
      this.loginForm3.password = encrypt(this.loginForm3.password);
      let data = await UserSubLogin(this.loginForm3);
      if (data.code == 200) {
        this.$message.success("登录成功");
        // token存缓存
        localStorage.setItem("customlogintoken", data.data.token);
        localStorage.setItem("customusernametitle", data.data.user.user.id);
        localStorage.setItem("usersublogin", data.data.user.user.isUserSub);
        localStorage.setItem(
          "usersubType",
          JSON.stringify(data.data.user.user)
        );
        this.$router.push("/whiteList");
      } else {
        this.$message.error(data.msg);
      }
    },
  },
};
</script>

<style scoped>
.all {
  background-image: url("../assets/qingxi2.jpeg");
  min-height: 100vh;
  /* background-color: #eaebef; */
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-position: 100%;
  display: flex;
  -moz-flex-direction: column;
  -o-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
    flex-wrap: nowrap;
    justify-content: space-around
}
.dllogo{
  width: 150px; 
  height: 100%; 
  margin-right: 10px
}
.nav-top {
  color: rgba(0, 0, 0, 0.9);
  font-size: 21px;
  line-height: 22px;
  margin-left: 16px;
  padding-left: 17px;
  position: relative;
}
.goguanwang{
  display: none;
}
.nav-top:before {
  content: "";
  border-left: 1px solid rgba(0, 0, 0, 0.26);
  height: 20px;
  position: absolute;
  left: 0;
  top: 42%;
  margin-top: -8px;
}
.el-avatar {
  --el-avatar-text-color: var(--el-color-white);
  --el-avatar-bg-color: #ffffff;
}
.loginbody {
  /* border: 1px solid #21a7e1; */
  /* box-shadow: 5px 5px 10px 10px rgba(24, 68, 124, 0.4); */
  padding-top: 20px;
  /* border-radius: 6px; */
  position: relative;
}
.bottom-content {
  display: flex;
  margin-top: auto;
  text-align: center;
  /* padding-bottom: 1rem; */
  color: #494a4a;
  font-size: 12px;
}
.left-image-div {
  /* width: 60%; */
  width: 360px;
}
.login-form-div {
  min-width: 432px;
  min-height: 564px;
  width: 432px;
  height: 620px;
  margin-left: 60px;
  position: relative;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.Upperrightcorner {
  position: absolute;
  top: 0;
  right: 0;
  width: 81px;
  height: 36px;
  overflow: hidden;
  transform: skewX(38deg);
  transform-origin: top left;
  -webkit-transform: skewX(38deg);
  -webkit-transform-origin: top left;
}
.Upperrightc-span {
  display: block;
  padding: 8px 8px 8px 25px;
  line-height: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #003cab;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  text-decoration: none;
  border: none;
  outline: 0 none;
  cursor: pointer;
  transform: skewX(-38deg);
  transform-origin: top left;
  -ms-transform: skewX(-38deg);
  -ms-transform-origin: top left;
  -moz-transform: skewX(-38deg);
  -moz-transform-origin: top left;
  -webkit-transform: skewX(-38deg);
  -webkit-transform-origin: top left;
  -o-transform: skewX(-38deg);
  -o-transform-origin: top left;
  background-image: url("../assets/controlpanel-corner-bg.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 100%;
  background-color: transparent;
  transition: color 0.2 linear;
}
.denglubutton {
  width: 100%;
  height: 40px;
  margin-top: 20px;
  background-color: #0052d9;
  border: 1px solid transparent;
  color: #fff;
  border-radius: 0px;
}
.denglubutton:hover {
  background: #2670e8;
  border: 1px solid transparent;
  transition: background 0.3s ease;
}
.margin28 {
  margin: 28px 0 16px 0;
}
.heading {
  line-height: 36px;
  font-size: 28px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}

.subheading {
  margin-bottom: 16px;
  line-height: 36px;
  font-size: 28px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
}

.upgrade {
  color: #0052d9;
  font-size: 28px;
  line-height: 36px;
  font-weight: 600;
}
.panel-item {
  line-height: 30px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.9);
}
.mianfeishiyong {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;
  color: #0052d9;
  border: 1px solid #0052d9;
  background-color: #fff;
  font-size: 12px;
  line-height: 20px;
  padding: 7px 22px 7px 54px;
  box-sizing: border-box;
  transition: all 0.2s linear;
}
.mianfeishiyong::before {
  content: "";
  display: block;
  width: 36px;
  height: 36px;
  background-color: #0052d9;
  position: absolute;
  left: -5px;
  top: 0;
  transform: skewX(15deg);
}
.mianfeishiyong:after {
  content: "";
  position: absolute;
  display: block;
  width: 16px;
  height: 16px;
  top: 50%;
  margin-top: -8px;
  left: 5px;
  background-image: url("../assets/mianfeishiyong.svg");
  background-repeat: no-repeat;
}
.wxbottom {
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button__inner {
  padding: 15px;
}
::v-deep .el-tabs__nav-wrap:after {
  background-color: #ffffff;
}
::v-deep .el-tabs__nav .is-top {
  font-size: 18px;
}
@media screen and (max-width: 1440px) {
  .login-form-div {
    margin-left: 60px;
  }
}
@media screen and (max-width: 768px) {
  .dllogo{
    width: 100px;
  }
  .nav-top{
    font-size: 16px;
    font-weight: bold;
    display: none;
  }
  .goguanwang{
    display: inline;
    color: rgba(0, 0, 0, 0.9);
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    margin-left: 16px;
    padding-left: 17px;
    position: relative;
    cursor: pointer;
  }
  .goguanwang:before {
  content: "";
  border-left: 1px solid rgba(0, 0, 0, 0.26);
  height: 20px;
  position: absolute;
  left: 0;
  top: 42%;
  margin-top: -8px;
}
  .left-image-div {
    display: none;
  }
  .tixing{
    display: none !important;
  }
  .bottom-content{
    display: none;
  }
  .login-form-div {
    /* width: 100%; */
    margin-left: 0px;
    min-height: 564px;
    min-width: 356px;
    width: 356px;
    height: 620px;
  }
}

::v-deep .el-select__wrapper {
  box-shadow: none !important;
  border: 0;
  background: #fff;
  border-bottom: 1px solid var(--el-border-color);
  border-radius: 0;
}

::v-deep .el-input,
.el-input__wrapper {
  --el-input-border-color: #fff;
  /* --el-input-hover-border-color: #fff;
  --el-input-focus-border-color: #fff; */
  box-shadow: none !important;
  border: 0;
  background: #fff;
  border-bottom: 1px solid var(--el-border-color);
  border-radius: 0;
}
.el-form-item.is-error .el-input,
.el-input,
.el-select {
  --el-input-focus-border-color: transparent;
}
::v-deep.el-input__wrapper.is-focus,
.el-select__wrapper.is-focused {
  box-shadow: none;
  border: 0;
  border-bottom: 1px solid #409eff;
  border-radius: 0px;
}
::v-deep.el-select__wrapper.is-focused {
  box-shadow: none;
  border: 0;
  border-bottom: 1px solid #409eff;
  border-radius: 0px;
}
::v-deep.el-input__wrapper:hover {
  box-shadow: none;
  border: 0;
  border-bottom: 1px solid #409eff;
  border-radius: 0px;
}
::v-deep .el-select__wrapper:hover {
  box-shadow: none;
  border: 0;
  border-bottom: 1px solid #409eff;
  border-radius: 0px;
}

.scan-container-corner {
  position: absolute;
  width: var(--angle-size);
  height: var(--angle-size);
  background-color: var(--angle-color);
}
.corner-top-left {
  top: calc(0px - var(--angle-weight));
  left: calc(0px - var(--angle-weight));
}
.corner-top-right {
  top: calc(0px - var(--angle-weight));
  right: calc(0px - var(--angle-weight));
}
.corner-bottom-left {
  bottom: calc(0px - var(--angle-weight));
  left: calc(0px - var(--angle-weight));
}
.corner-bottom-right {
  bottom: calc(0px - var(--angle-weight));
  right: calc(0px - var(--angle-weight));
}

.scan-container {
  width: var(--container-width);
  height: var(--container-height);
}
.scan-container1 {
  position: absolute;
  width: inherit;
  height: inherit;
  z-index: 0;
}
.scan-container2 {
  position: absolute;
  width: inherit;
  height: inherit;
  z-index: 10;
  background-color: white;
}
.scan-container3 {
  position: absolute;
  width: inherit;
  height: inherit;
  z-index: 20;
  overflow: hidden;
}
.scan-animate {
  width: inherit;
  height: var(--scan-wake-size);
  animation: scan 3s ease-in-out infinite;
}

@keyframes scan {
  0% {
    /*最开始块从顶部往下移动，块的位置需要溢出容器，处于容器顶部上方，块的背景颜色从底部到顶部由绿色逐渐透明*/
    margin-top: calc(0px - var(--scan-wake-size));
    background: linear-gradient(#0000 0%, var(--scan-wake-color) 100%);
  }
  49% {
    /*动画进行到一半时间时，块必须移动到容器底部并溢出，完成从上到下扫描效果*/
    margin-top: var(--container-height);
    background: linear-gradient(#0000 0%, var(--scan-wake-color) 100%);
  }
  50% {
    /*调转颜色方向，准备往回扫（从下往上）*/
    margin-top: var(--container-height);
    background: linear-gradient(var(--scan-wake-color) 0%, #0000 100%);
  }
  100% {
    /*往回扫*/
    margin-top: calc(0px - var(--scan-wake-size));
    background: linear-gradient(var(--scan-wake-color) 0%, #0000 100%);
  }
}

.top {
  display: flex;
  -moz-flex-direction: column;
  -o-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  display: flex;
  justify-content: center;
  /* z-index: 1000; */
  width: 100%;
  /* background-color: transparent; */
}

.top .tip {
  position: absolute;
  height: 120px;
  width: 120px;
  right: -60px;
  top: -60px;
  transform: rotate(45deg);
  background-color: #409eff;
  font-size: 12px;
  cursor: pointer;
}
.bottom {
  position: fixed;
  bottom: 0px;
  padding: 10px 0 0 0;
  /* background: #ffffff; */
  display: flex;
  justify-content: center;
  /* z-index: 1000; */
  width: 100%;
}
::v-deep .phoneyzm .el-form-item__content {
  display: flex;
}
::v-deep .el-input__inner {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0px;
}

::v-deep iframe {
  width: 150px;
  height: 150px;
}
.freezhuce {
  cursor: pointer;
}
::v-deep .freezhuce:hover {
  cursor: pointer;
  color: red !important;
}
.zhuzhanghao {
  padding: 10px;
  border: 1px solid #c3cfe8;
  font-size: 15px;
  background: #f0f1f3;
  cursor: pointer;
}
::v-deep .el-tabs__item.is-active {
  color: #0052d9;
}
::v-deep .el-tabs__active-bar {
  background-color: #0052d9;
}
::v-deep .el-tabs__item:hover {
  color: #0052d9;
}
::v-deep .tixing {
  display: flex;
  align-items: center;
  padding:0 30px;
  height:38px;
  line-height: 38px;
  margin-top:15px;
  background: #d7e2fa;
  color: #163ba5;
  border-radius: 0px;
}
</style>
